<script>
import Vue from 'vue';
import { mapState, mapGetters } from 'vuex';
import moment from 'moment-timezone';
import { Dialog,
    Message,
    Popover } from 'element-ui';
import Panel from '~/components/panel/components/panel';
import SocialCovers from '~/api/social_covers';
import SocialSelectButton from './social_select_button';
import VueButton from '~/components/button/components/button';
import EmptyContent from '~/components/empty_content/components/empty_content';
import FormVuex from '~/components/form/mixins/form_vuex';
import FormGroup from '~/components/form/components/form_group';
import SelectInfinite from '~/components/select/components/select_infinite';
import ImageHelper from '~/directives/image_helper';
import Loader from '~/components/loader/components/loader';
import Permissions from '~/services/permissions/vue_permissions';
import FacebookAccountsModal from '~/bundles/integrations/components/facebook_accounts_modal';
import SkeletonLoader from '~/components/loader/components/skeleton_loader';
import OembedPreview from '~/bundles/oembed/components/oembed_preview';
import { SocialMediaTypeMixin } from '~/services/social_media_service';
import { DynamicWebsiteFilterMixin } from '~/bundles/media/constants/dynamic_website_filters';
import VueAlert from '~/components/alert/components/alert';

Vue.use(Dialog);
Vue.use(Permissions);
Vue.use(Popover);

function replaceLast(x, y, z) {
    const a = x.split('');
    a[x.lastIndexOf(y)] = z;
    return a.join('');
}

export default Vue.component('social-cover-share', {

    components: {
        Panel,
        SocialSelectButton,
        VueButton,
        VueAlert,
        EmptyContent,
        FormGroup,
        SelectInfinite,
        Loader,
        FacebookAccountsModal,
        SkeletonLoader,
        OembedPreview,
    },

    mixins: [FormVuex, SocialMediaTypeMixin, DynamicWebsiteFilterMixin],

    props: {
        showNetworks: {
            type: Boolean,
            default: true,
        },

        showMediaLibrary: {
            type: Boolean,
            default: true,
        },
    },

    data() {
        return {
            mediaId: null,
            savedMediaId: null,
            checked: false,
            modalOpen: false,
            previewImageLoading: true,
            postDateOptions: {
                disabledDate(date) {
                    return moment(date).isBefore(moment(), 'day');
                },
            },
        };
    },

    computed: {
        ...mapState('socialShare', [
            'isPosting',
            'isLoading',
            'formData',
            'social_networks',
            'websites',
            'media',
            'twitter_url_length',
            'is_video_link',
            'recent_message',
        ]),

        ...mapGetters('socialShare', [
            'post_message_length',
            'linkedInSelected',
            'twitterSelected',
        ]),

        dispatchAction() {
            return this.formData.id ? 'socialShare/updatePost' : 'socialShare/postForm';
        },

        postMessageLengthRemaining() {
            const messageLength = this.formData.post_message.length;
            return messageLength
                ? this.post_message_length - messageLength
                : this.post_message_length;
        },

        postMessageContainsMention() {
            if (this.twitterSelected) {
                const mentionRegex = /\B@\w+/;
                const message = this.formData.post_message;
                if (message.match(mentionRegex)) {
                    return true;
                }
                return false;
            }
            return false;
        },

        postNowButtonDisabled() {
            return this.postMessageLengthRemaining < 0 || this.isPosting;
        },

        scheduleButtonDisabled() {
            return this.postNowButtonDisabled || !this.formData.post_date;
        },

        networkOptions() {
            return this.social_networks.filter((item) => {
                if (this.formData.video_url) {
                    return (item.is_shareable && (item.system_name === 'facebook' || item.system_name === 'instagram' || item.system_name === 'linkedin'));
                }
                    return item.is_shareable;
            });
        },

        removalDateOptions() {
            const postDate = this.formData.post_date;
            return {
                disabledDate(date) {
                    let isDisabled = moment(date).isBefore(moment(), 'day');

                    if (postDate) {
                        isDisabled = moment(date).isBefore(moment(postDate), 'day');
                    }
                    return isDisabled;
                },
            };
        },

        disableWebsiteSelect() {
            return !parseInt(this.media.social_user_website_editable)
                   && this.formData.media_id
                   && this.formData.media_id > 0;
        },

        disablePostMessageInput() {
            return !parseInt(this.media.social_media_post_message_editable)
                   && this.formData.media_id
                   && this.formData.media_id > 0;
        },

        postToNetworkNames() {
            return [...new Set(this.formData.social_networks.map((item) => item.system_name))];
        },

        buttonPopoverNames() {
            const networkNames = this.postToNetworkNames.join(', ');
            return replaceLast(networkNames, ', ', ' and ');
        },
    },
    methods: {
        open(commitModule) {
            this.modalOpen = true;
        },

        getFormData() {
            const mediaId = this.formData.saved_media_id ? this.formData.saved_media_id : this.mediaId;
            this.$store.dispatch('socialShare/getFormData', mediaId);
        },

        postDateIsSet() {
            return !this.formData.post_date;
        },

        formatForm() {
            return { ...this.model, post_time: moment(this.model.post_time.data).format('HH:mm:ss A') };
        },

        schedule() {
            this.updateFormData(false, 'post_now');
            this.submit('Successfully Scheduled');
        },

        postNow() {
            this.updateFormData(true, 'post_now');
            this.submit('Successfully Posted');
        },

        updateFormData(newValue, schema) {
            this.$store.commit('socialShare/updateFormData', {
                [schema]: newValue,
            });
        },

        submit(successMessage) {
            this.$store.dispatch(this.dispatchAction).then((response) => {
                Message({
                    type: 'success',
                    message: successMessage,
                    showClose: true,
                });
                this.commitChanges(response);
                this.resetFormData();
                this.closePopovers();
                this.modalOpen = false;
            }).catch((error) => {
                Message({
                    type: 'error',
                    message: error.responseJSON.message,
                    showClose: true,
                });
            });
        },

        commitChanges(response) {
            const postId = this.formData.id;
            const module = this.formData.post_now ? 'postedFeed' : 'scheduledFeed';
            if (!this.$store.state[module]) return;

            if (postId) {
                return this.$store.commit(`${module}/updatePost`, response.post);
            }
            return this.$store.commit(`${module}/addPosts`, response);
        },

        onClose(done) {
            this.resetFormData();
            this.closePopovers();
            done();
        },

        resetFormData() {
            this.formData.post_now = false;
            this.$store.commit('socialShare/resetFormData');
            this.mediaId = null;
            this.previewImageLoading = true;
        },

        closePopovers(postPopover) {
            if (this.$refs.postPopover) {
                this.$refs.postPopover.doClose();
                this.$refs.schedulePopover.doClose();
            }
        },

        setNetwork(isChecked, value) {
            if (isChecked) {
                this.$store.commit('socialShare/addSocialNetwork', value);
            } else {
                this.$store.commit('socialShare/removeSocialNetwork', value);
            }
        },

        addWebsite(value) {
            this.updateFormData(value, 'website');
        },

        updateNetworkConnection(name) {
            if (name === 'facebook') {
                this.$refs.facebookAccountsModal.isOpen = true;
            } else {
                this.getFormData();
            }
        },

        hasNetwork(allowed, id) {
            return allowed.split(',').includes(id);
        },

        mediaLibraryChange(mediaId, obj) {
            if (obj && obj.saved_media_id) {
                this.mediaId = obj.saved_media_id;
                this.$store.commit('socialShare/updateFormEditableParam', true);
            } else if (obj && obj.media_id) {
                this.mediaId = obj.media_id;
                this.$store.commit('socialShare/updateFormEditableParam', false);
            } else {
                this.mediaId = null;
            }
            this.getFormData(this.mediaId);
        },

        buildMediaLibraryPreview(asset_folder_path) {
            return `/${asset_folder_path}/preview.jpg`;
        },

        hideImageLoader() {
            this.previewImageLoading = false;
        },

        remoteMethod(params) {
            return SocialCovers.searchApproved(params);
        },

        previewLink() {
            window.open(this.formData.website, '_blank');
        },
    },
});
</script>

<!--
    The 'SocialMediaApprovedMediaLibrary' permission was removed from all roles.
    Also, the showMediaLibrary prop is now bound to this permission where it was used, making it always false.
    This deprecates the following elements of this component:
    props:
        showMediaLibrary
    methods:
        mediaLibraryChange
        remoteMethod
        buildMediaLibraryPreview
        hasNetwork
    template
        Select approved media
        empty content with title "No Available Social Media Posts Found"

    Remove these deprecated elements when the change has been validated
 -->

<template>
    <div>
        <el-dialog
            v-if="modalOpen"
            title="Social Post"
            :visible.sync="modalOpen"
            :before-close="onClose"
        >
            <loader :is-loading="isLoading" />

            <template v-if="networkOptions.length">
                <div>
                    <div
                        v-if="formData.video_url"
                        class="embed-responsive embed-responsive-16by9 m-b-15"
                    >
                        <video
                            width="400"
                            controls
                        >
                            <source
                                :src="formData.video_url"
                                type="video/mp4"
                            >
                            Your browser does not support HTML5 video.
                        </video>
                    </div>

                    <oembed-preview
                        v-else-if="is_video_link"
                        class="m-b-15"
                        :value="formData.post_image_url"
                        :show-input="false"
                    />

                    <div
                        v-else-if="formData.post_image_url"
                        class="m-b-15"
                    >
                        <skeleton-loader
                            :is-loading="previewImageLoading"
                            type="block"
                            height="150px"
                            width="100%"
                            position="relative"
                        />

                        <img
                            v-show="!previewImageLoading"
                            id="social-preview-image"
                            class="img-responsive center"
                            :src="formData.post_image_url"
                            @load="hideImageLoader"
                            @error="hideImageLoader"
                        >
                    </div>

                    <div
                        v-if="showNetworks"
                        class="clear-hide m-b-5 d-flex flex-wrap"
                    >
                        <div
                            v-for="network in networkOptions"
                            class="m-b-10 m-r-10"
                        >
                            <social-select-button
                                :name="network.network_name"
                                :system-name="network.system_name"
                                :account-id="network.account_id"
                                :page-id="network.page_id"
                                :network-id="network.id"
                                :selected="formData.social_networks"
                                :is-connected="network.user_connected"
                                :profile-img="network.profile_img"
                                :username="network.user_name"
                                :account-type="network.account_type"
                                :is-permitted="network.is_permitted"
                                @change="setNetwork"
                                @connect="updateNetworkConnection"
                            />
                        </div>
                    </div>

                    <form-group
                        v-if="$hasAccess('SocialMediaApprovedMediaLibrary') && showMediaLibrary"
                        label="Select Approved Media"
                    >
                        <select-infinite
                            :value="mediaId"
                            :remote-method="remoteMethod"
                            data-path="media"
                            options-key="unique_id"
                            option-label="name"
                            option-value="unique_id"
                            paging-strategy="page"
                            @change="mediaLibraryChange"
                        >
                            <template slot-scope="props">
                                <div class="media-list-select">
                                    <img
                                        v-image-helper="350"
                                        :src="buildMediaLibraryPreview(props.item.asset_folder_path)"
                                        class="media-list-select__thumbnail"
                                    >
                                    <div class="media-list-select__body">
                                        <div class="media-list-select__title">
                                            {{ props.item.name }}
                                        </div>

                                        <span
                                            v-if="hasNetwork(props.item.social_media_networks, SocialMediaTypes.FACEBOOK)"
                                            class="media-list-select__social-icon font-facebook-blue"
                                        >
                                            <i
                                                class="fa fa-facebook-square"
                                                aria-hidden="true"
                                            />
                                        </span>

                                        <span
                                            v-if="hasNetwork(props.item.social_media_networks, SocialMediaTypes.TWITTER)"
                                            class="media-list-select__social-icon font-twitter-blue"
                                        >
                                            <i
                                                class="fa fa-twitter-square"
                                                aria-hidden="true"
                                            />
                                        </span>

                                        <span
                                            v-if="hasNetwork(props.item.social_media_networks, SocialMediaTypes.LINKEDIN)"
                                            class="media-list-select__social-icon font-linkedin-blue"
                                        >
                                            <i
                                                class="fa fa-linkedin-square"
                                                aria-hidden="true"
                                            />
                                        </span>
                                    </div>
                                </div>
                            </template>
                        </select-infinite>
                    </form-group>

                    <form-group label="Share a link">
                        <vue-button
                            v-if="media.social_user_website == DynamicWebsiteFilters.USER_WEBSITE"
                            class="m-l-5 m-b-2"
                            size="xs"
                            type="link"
                            @click="previewLink"
                        >
                            Preview
                        </vue-button>
                        <el-select
                            v-model="formData.website"
                            filterable
                            allow-create
                            clearable
                            :disabled="disableWebsiteSelect"
                            placeholder="Add or create a url"
                            @change="addWebsite"
                        >
                            <el-option
                                v-for="item in websites"
                                :key="item"
                                :value="item"
                            />
                        </el-select>
                    </form-group>

                    <form-group
                        label="Message"
                        :hint="`${postMessageLengthRemaining} characters remaining`"
                    >
                        <textarea
                            class="form-control m-b-15"
                            :disabled="disablePostMessageInput"
                            :value="formData.post_message"
                            :maxlength="post_message_length"
                            @input="updateFormData($event.target.value, 'post_message')"
                        />
                        <vue-alert
                            v-if="postMessageContainsMention"
                            type="warning"
                            :closable="false"
                        >
                            <i
                                slot="icon"
                                class="el-icon-picture"
                            />
                            <strong>@mentions are not allowed.</strong><br>
                            <small>Please remove any @mentions from your tweet.
                                They will be stripped from the message before
                                being posted to X.</small>
                        </vue-alert>
                    </form-group>

                    <form-group label="Post Date">
                        <el-date-picker
                            v-model="formData.post_date"
                            type="date"
                            format="MM/dd/yyyy"
                            placeholder="Pick a day"
                            :picker-options="postDateOptions"
                            @change="updateFormData($event, 'post_date')"
                        />
                    </form-group>

                    <form-group label="Post Time">
                        <timepicker
                            :start-value="formData.post_time"
                            :minute-interval="15"
                            @change="updateFormData($event, 'post_time')"
                        />
                    </form-group>

                    <form-group label="Removal Date">
                        <el-date-picker
                            v-model="formData.remove_date"
                            type="date"
                            format="MM/dd/yyyy"
                            placeholder="Pick a day"
                            :picker-options="removalDateOptions"
                            @change="updateFormData($event, 'remove_date')"
                        />
                    </form-group>
                </div>
            </template>
            <template v-else-if="!isLoading">
                <div v-if="showMediaLibrary">
                    <empty-content
                        title="No Available Social Media Posts Found"
                        :is-loading="isLoading"
                    >
                        <i
                            slot="icon"
                            class="el-icon-picture"
                        />
                        We couldn't find any approved social media posts to share
                    </empty-content>
                </div>
                <div v-else-if="!networkOptions.length">
                    <empty-content
                        title="No Available Social Networks"
                        :is-loading="isLoading"
                    >
                        <i
                            slot="icon"
                            class="el-icon-picture"
                        />
                        No social networks have been configured for this asset
                    </empty-content>
                </div>
            </template>

            <span slot="footer">
                <template v-if="networkOptions.length">
                    <el-popover
                        ref="schedulePopover"
                        placement="top"
                        width="200"
                        trigger="hover"
                    >
                        <span class="text-black">{{ `Schedule for ${buttonPopoverNames}` }}</span>

                        <vue-button
                            slot="reference"
                            class="m-r-5"
                            type="primary"
                            :loading="isPosting && formData.post_now === false"
                            loading-text="Scheduling"
                            :disabled="scheduleButtonDisabled"
                            @click="schedule"
                        >
                            Schedule
                        </vue-button>
                    </el-popover>

                    <el-popover
                        ref="postPopover"
                        placement="top"
                        width="200"
                        trigger="hover"
                    >
                        <span class="text-black">{{ `Post to ${buttonPopoverNames}` }}</span>

                        <vue-button
                            v-if="!formData.id"
                            slot="reference"
                            type="primary"
                            :disabled="postNowButtonDisabled"
                            :loading="isPosting && formData.post_now === true"
                            loading-text="Posting"
                            @click="postNow"
                        >
                            Post Now
                        </vue-button>
                    </el-popover>
                </template>
            </span>
        </el-dialog>

        <facebook-accounts-modal
            ref="facebookAccountsModal"
            :should-reload="false"
            @connect="updateNetworkConnection"
        />
    </div>
</template>
